module.exports = __webpack_public_path__ + "static/0060-b4ccb3d842b77007e2fa3aacd3cdb9f8.png";